<div class="flex h-screen w-screen">
	<div class="auth-bg bg-blue-200 hidden flex-1 items-center justify-center bg-cover lg:flex">
		<div class="max-w-2xl space-y-4 p-8 text-center text-sky-900">
			<img src="assets/svg/devoltec.svg" alt="" />
			<h1 class="text-4xl font-bold">"Optimización y Control en Tiempo Real"</h1>
			<p class="text-xs font-light">
				Nuestro <span class="cursor-pointer font-medium text-[#0085a1]">Sistema de Ejecución de Fabricación</span> (MES) 
				permite un control total de la producción, brindando información en tiempo real para <span class="cursor-pointer font-medium text-[#0085a1]">maximizar la eficiencia</span>, 
				<span class="cursor-pointer font-medium text-[#0085a1]">reducir costos</span> y <span class="cursor-pointer font-medium text-[#0085a1]">mejorar la calidad</span>. 
				Con herramientas avanzadas de monitoreo y análisis, transforma tu planta en un entorno <span class="cursor-pointer font-medium text-[#0085a1]">inteligente</span> 
				y <span class="cursor-pointer font-medium text-[#0085a1]">altamente productivo</span>.
			</p>
		</div>
	</div>
	<div class="bg-background flex flex-1 items-center justify-center">
		<div class="max-w-md overflow-y-auto px-4 sm:w-[500px]">
			<!-- logo -->
			<div class="flex justify-center items-center h-screen">
				<div class="flex items-center justify-center w-full flex-col">
					<div class="w-[325px] -mt-28">
						<div class="flex items-center justify-center">
							<img class="w-52 h-auto" src="assets/svg/demo-logo.svg" alt="Logo Devoltec"
								loading="lazy" />
						</div>

						@if (innerWidth > LOGIN_WIDTH_CHANGE_PLACEMENT) { 
							<div class="w-full flex items-center justify-end">
								<button (click)="changeRFID()"
									class="text-black bg-gray-200 hover:bg-gray-300 focus:ring-2 focus:ring-gray-400 font-medium rounded-2xl text-sm px-2.5 py-2.5 dark:bg-blue-600 dark:hover:bg-blue-700 focus:outline-none dark:focus:ring-blue-800 mt-5">
									<svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"
										xmlns="http://www.w3.org/2000/svg">
										<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
											d="M8 7h12m0 0l-4-4m4 4l-4 4m0 6H4m0 0l4 4m-4-4l4-4"></path>
									</svg>
								</button>
							</div>
						}

						@if (innerWidth < LOGIN_WIDTH_CHANGE_PLACEMENT) { 
							<app-login-form></app-login-form>
						} @else {
							@if (!showRFID) {
							<app-login-form></app-login-form>
							} @else {
							<app-rfid-form></app-rfid-form>
							}
						}
				</div>
			</div>
		</div>
	</div>
</div>
</div>